import ShiftControls from './component';

export default ShiftControls;
